import React from 'react'
import { Icon } from "@iconify/react";

const ActionButton = ({ iconSrc, iconImg, icon, tone = "indigo", label, onClick, isLoading, transcribeLoading, disabled }) => {
    return (
        <div
            className={`vr-rd-tool vr-tone-${tone}${(isLoading || disabled) ? " is-busy" : ""}${disabled ? " is-disabled" : ""}${label.length > 12 ? " is-long" : ""}`}
            role="button"
            tabIndex={0}
            aria-disabled={isLoading || disabled}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") e.currentTarget.click(); }}
            onClick={() => {
                if (!disabled) {
                    onClick();
                }
            }}
        >

            {transcribeLoading ? (
                <span className="vr-icon-tile">
                    <span className="vr-spinner" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </span>
                </span>
            ) : (
                <>
                    {iconImg ? (
                        <span className="vr-icon-tile has-img">
                            <img src={iconImg} alt={label.toLowerCase()} />
                        </span>
                    ) : icon ? (
                        <span className="vr-icon-tile" role="img" aria-label={label.toLowerCase()}>
                            <Icon icon={icon} width={20} height={20} />
                        </span>
                    ) : (
                        <img
                            src={iconSrc}
                            alt={label.toLowerCase()}
                        />
                    )}
                </>
            )}
            <p>{label}</p>
        </div>
    );
};

export default ActionButton
